import { Button, Modal, Radio, Row, Typography } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { CancelButton, SubmitButton } from 'modules/dashboard/styles/dashboard';

import { EndRepeatModalContainer, FooterContainer } from '../styles/event';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { EventApplyOption } from '../core/enum';

export const EditRecurringEventModal = ({
  onCancel,
  value,
  onChangeChecked,
  onSubmit,
}: {
  onCancel: () => void;
  value: EventApplyOption;
  onChangeChecked: (value: EventApplyOption) => void;
  onSubmit: () => void;
}) => {
  return (
    <EndRepeatModalContainer>
      <Modal
        header={
          <Typography variant="h4" weight={500} color={COLOR.surfaceNeutralBold['neutral-11']}>
            Edit recurring event
          </Typography>
        }
        closeIconStyle={{
          width: 24,
          height: 24,
        }}
        modalKey={MODAL_KEY.EDIT_RECURRING_EVENT}
        style={{ background: COLOR_CONFIG.white }}
        footer={
          <FooterContainer>
            <CancelButton variant="outlined" onClick={onCancel}>
              Cancel
            </CancelButton>
            <SubmitButton variant="contained">
              <Typography
                variant="body-2"
                color={COLOR_CONFIG.white}
                weight={600}
                onClick={onSubmit}
              >
                Save
              </Typography>
            </SubmitButton>
          </FooterContainer>
        }
      >
        <Typography
          style={{ marginBottom: 6 }}
          variant="body-2"
          color={COLOR.surfaceNeutralBold['neutral-11']}
        >
          Invitees will be notified about the updates.
        </Typography>
        <Radio
          checked={value === EventApplyOption.ONLY_THIS_EVENT}
          onClick={() => onChangeChecked(EventApplyOption.ONLY_THIS_EVENT)}
          style={{
            marginRight: 10,
            marginBottom: 8,
          }}
        >
          This event only
        </Radio>

        <Radio
          checked={value === EventApplyOption.THIS_AND_FUTURE_EVENTS}
          onClick={() => onChangeChecked(EventApplyOption.THIS_AND_FUTURE_EVENTS)}
          style={{
            marginRight: 10,
          }}
        >
          This and following events
        </Radio>
      </Modal>
    </EndRepeatModalContainer>
  );
};
